module.exports = __webpack_public_path__ + "img/download-alb.9adc8505.svg";